/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import Switch from './Switch';

Vue.component('ui-switch', Switch);

